import { useCallback, useEffect, useState } from 'react';
import notificationService from '../services/notificationService';
import exportRunService from '../services/exportRunService';
import { authService } from '../services/authService';

export function useBackgroundProcesses({ enabled = false } = {}) {
  const [runs, setRuns] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!authService.isAuthenticated()) {
      setRuns([]);
      setActiveCount(0);
      return;
    }

    setLoading(true);
    try {
      setError(null);
      const [kardexRes, exportRes] = await Promise.all([
        notificationService.listKardexRecalculateRuns({ limit: 20 }),
        exportRunService.list({ limit: 20 }),
      ]);

      const kardexRuns = kardexRes?.success
        ? (Array.isArray(kardexRes.data) ? kardexRes.data : []).map((run) => ({
            ...run,
            process_kind: 'kardex',
          }))
        : [];

      const exportRuns = exportRes?.success
        ? (Array.isArray(exportRes.data) ? exportRes.data : []).map((run) => ({
            ...run,
            process_kind: 'export',
          }))
        : [];

      const merged = [...kardexRuns, ...exportRuns].sort((a, b) => {
        const da = new Date(a.created_at || 0).getTime();
        const db = new Date(b.created_at || 0).getTime();
        return db - da;
      });

      const kardexActive = Number(kardexRes?.active_count) || 0;
      const exportActive = Number(exportRes?.active_count) || 0;

      setRuns(merged);
      setActiveCount(kardexActive + exportActive);
    } catch (err) {
      console.error('Error al cargar procesos en segundo plano:', err);
      setError('No se pudieron cargar los procesos en segundo plano.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled || !authService.isAuthenticated()) {
      return undefined;
    }

    refresh();
  }, [enabled, refresh]);

  return {
    runs,
    activeCount,
    loading,
    error,
    refresh,
  };
}
